export default __webpack_public_path__ + "static/media/illustration-elements_mobile-home-gradient (1).6ba48520.svg";